import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
    selector: 'app-modal',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
    ],
    templateUrl: './modal.component.html',
})
export class ModalComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ModalComponent>,
        private router: Router
    ) {}

    resumeDraft(draftDataLength) {
        if (draftDataLength > 1) {
            this.dialogRef.close();
            this.router.navigate(['/draft']);
        } else if (draftDataLength == 1) {
            this.dialogRef.close({ data: 'resumeDraft' });
        }
    }

    startNewApp() {
        this.dialogRef.close({ data: 'startNewApp' });
    }
}
